import { Grid, Stack } from "@mui/material";
import { EditButton, Show, Tab, TabbedShowLayout, TopToolbar } from "react-admin";
import AppConstantMetaShow from "./AppConstantMetaShow";

const AppConstantShowActions = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);

const RenderCTAButtons = (props: any) => {
    
  return (
    <Stack p={2}>
      <Grid container spacing={2} justifyContent="flex-end">  
      </Grid>
    </Stack>
  );
};

const AppConstantTabShow = () => {

  return (
    <TabbedShowLayout>
      <Tab label={"Details"}>
        <AppConstantMetaShow/>
      </Tab>
    </TabbedShowLayout>
  );
};
const AppConstantShow = (props: any) => {
  return (
    <div>
      <Show {...props} actions={<AppConstantShowActions />}>
        <RenderCTAButtons
        />
        <AppConstantTabShow />
      </Show>
    </div>
  );
};
export default AppConstantShow;